export const countryEnum = {
  CN: 'CN'
} as const
